module.exports = __webpack_public_path__ + "static/media/phone-george.a968e0d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-george.svg
// module id = 343
// module chunks = 21